// src/utils/post/comments/createComment.ts

interface FormData {
    author: string;
    authorEmail?: string;
    content: string;
    parent?: number;
}

export const createComment = async (formData: FormData, currentPostId: number): Promise<number> => {
    try {
        const response = await fetch('/api/post/submit-comment', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                author: formData.author,
                authorEmail: formData.authorEmail || 'no.mail@noemail.noemail',
                content: formData.content,
                commentOn: currentPostId,
                parent: formData.parent || 0,
            }),
        });

        const result = await response.json().catch(() => ({}));

        // Show the server's own message (e.g. «log in first» on 401) instead of a generic one.
        if (!response.ok) {
            throw new Error(result?.error || result?.message || 'مشکلی در ارتباط با سرور پیش آمد.');
        }

        // 1. Check if WordPress threw a GraphQL error
        if (result.errors && result.errors.length > 0) {
            throw new Error(result.errors[0].message);
        }

        // 2. Safety check for custom API errors (like our Bot detection)
        if (result.error) {
            throw new Error(result.error);
        }

        // 3. Safety check: Ensure the comment object actually exists
        if (!result?.data?.createComment?.comment) {
            throw new Error('دیدگاه شما توسط سرور رد شد.');
        }

        return result.data.createComment.comment.databaseId;
    } catch (error: any) {
        console.error('Error in createComment API:', error);
        throw error;
    }
};
